import React from 'react';
import { paths } from 'routes';
import { IconWrapper } from 'components/Icon';
import { useAuth } from 'lib/auth';
import { useNavbar } from 'lib/navbarContext';
import { isBuyer } from 'utils/companyType';
import { useTheme, useMediaQuery } from '@mui/material';

const group = (title, icon, subItems) => {
  if (subItems.length === 0) return [];
  if (subItems.length === 1) return subItems;
  return [{ title, Icon: ({ sx }) => <IconWrapper icon={icon} sx={sx} />, subItems }];
};

export function useNavItems() {
  const { account, user } = useAuth();
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const { closeMenu } = useNavbar();

  const items = [
    {
      title: 'Home',
      path: paths.homepage,
      Icon: ({ sx }) => <IconWrapper icon="home" sx={sx} />,
    },
    {
      title: 'Blog',
      path: paths.blog,
      Icon: ({ sx }) => <IconWrapper icon="document" sx={sx} />,
    },
    ...group('Procurement', 'documentText', [
      ...account.super_admin ?
      [{
        title: 'Agreements',
        path: paths.frameworkAgreement,
        Icon: ({ sx }) => <IconWrapper icon="documentText" sx={sx} />,
      }] : [],
      {
        title: 'Directs',
        path: paths.directs,
        Icon: ({ sx }) => <IconWrapper icon="clipboardDocumentList" sx={sx} />,
      },
      ...(!(user?.Company?.Type === 'buyer' && user?.Company?.sector === 'private')) ?
      [{
        title: 'DPS',
        path: paths.dps,
        Icon: ({ sx }) => <IconWrapper icon="documentCheck" sx={sx} />,
      }] : [],
    ]),
    ...group('Companies', 'buildingOffice2', [
      ...(account.super_admin || isBuyer(user)) ?
      [{
        title: 'Find Suppliers',
        path: paths.supplierSearch,
        Icon: ({ sx }) => <IconWrapper icon="marketplace" sx={sx} />,
      }] : [],
      ...account.super_admin ?
      [{
        title: 'Buyers',
        path: paths.buyers,
        Icon: ({ sx }) => <IconWrapper icon="buildingOffice" sx={sx} />,
      }] : [],
      ...account.super_admin ?
      [{
        title: 'Suppliers',
        path: paths.suppliers,
        Icon: ({ sx }) => <IconWrapper icon="buildingOffice2" sx={sx} />,
      }] : [],
      ...account.super_admin ?
      [{
        title: 'Users',
        path: paths.users,
        Icon: ({ sx }) => <IconWrapper icon="users" sx={sx} />,
      }] : [],
    ]),
    ...group('Job Ads', 'inboxStack', [
      ...(user?.Company?.Type === 'supplier' || user?.Company?.Type === 'buyer' || account.super_admin ) ?
      [{
        title: account.super_admin ? 'All Ads' : 'My Ads',
        path: account.super_admin ? paths.jobAds : paths.myJobAds,
        Icon: ({ sx }) => <IconWrapper icon="inboxStack" sx={sx} />,
      }] : [],
      ...(user?.Company?.Type === 'supplier' || user?.Company?.Type === 'buyer' || account.super_admin ) ?
      [{
        title: 'Applications',
        path: paths.applications,
        Icon: ({ sx }) => <IconWrapper icon="briefcase" sx={sx} />,
      }] : [],
    ]),
    ...group('Administration', 'cog8Tooth', [
      ...account.super_admin ?
      [{
        title: 'Payments',
        path: paths.subscriptions,
        Icon: ({ sx }) => <IconWrapper icon="subscription" sx={sx} />,
      }] : [],
      ...account.super_admin ?
      [{
        title: 'Subscribers',
        path: paths.subscribers,
        Icon: ({ sx }) => <IconWrapper icon="atSymbol" sx={sx} />,
      }] : [],
      ...account.super_admin ?
      [{
        title: 'Statistics',
        path: paths.statistics,
        Icon: ({ sx }) => <IconWrapper icon="chart" sx={sx} />,
      }] : [],
    ]),
  ];

  if (isLg) {
    items.push({
      title: closeMenu ? 'Expand Menu' : 'Collapse Menu',
      action: 'toggleMenu',
      Icon: ({ sx, closed }) => (
        <IconWrapper icon={closed ? 'arrowRight' : 'arrowLeft'} sx={sx} />
      ),
    });
  }

  return items;
}
